/**
 * @file agent 反馈 hook
 * @author malcolmmzma
 */

import React, { useCallback, useMemo } from 'react';
import FeedbackWidget, { IFeedbackWidgetRef } from './FeedbackWidget';
import FeedbackContent, { FeedbackContentRef } from './FeedbackContent';
import { message } from '@tencent/ptp-fe-common';
import { sendUserFeedback } from '../../../../api/analysis';

const useAgentFeedback = (props: {
  productName?: string; // 产品名称
  agentId?: number; // Agent ID
  sessionId?: string; // 会话 ID
}) => {
  const { productName, agentId, sessionId } = props;

  const widgetRef = React.useRef<IFeedbackWidgetRef>(null);
  const contentRef = React.useRef<FeedbackContentRef>(null);

  const handleSubmit = useCallback(async () => {
    contentRef.current?.onSubmit(async (data) => {
      try {
        await sendUserFeedback({
          agent_id: agentId ?? 0,
          session_id: sessionId ?? '',
          score: data.score,
          reasons: data.discontent?.join(','),
          suggestion: data.suggestion,
        });
        widgetRef.current?.changeStatus('done');
      } catch (error) {
        message.error('提交反馈失败，请稍后重试');
        console.error('submit feedback error: ', error);
      }
    });
  }, [agentId, sessionId]);

  const feedbackContent = useMemo(() => <FeedbackContent productName={productName} ref={contentRef} />, [productName]);

  const feedbackWidget = useMemo(
    () => (
      <FeedbackWidget ref={widgetRef} onSubmit={handleSubmit}>
        {feedbackContent}
      </FeedbackWidget>
    ),
    [feedbackContent, handleSubmit],
  );

  return { feedbackWidget, feedbackContent, submit: handleSubmit, trigger: () => widgetRef.current?.show() };
};

export default useAgentFeedback;
